<template>
  <ChartCard :class="'card-'+theme" v-if="!loadingLastWeekOrders" :chart-data="lineChart.data" :chart-options="lineChart.options" :responsive-options="lineChart.responsiveOptions">
    <template slot="header" >
      <h5 class="card-title" :class="'card-title-'+theme">Gráfico de Evolução Financeira</h5>
      <p class="card-category" :class="'card-category-'+theme">[Banca em $ x Período]<br />Rendimentos: Hoje: ${{ todayProfit }} | Esta Semana: ${{ weekProfit }}</p>
    </template>
    <template slot="footer">
      <hr>
      <div class="stats" :class="'card-title-'+theme">
        <i class="fa fa-history"></i> Dados dos últimos 7 dias
      </div>
    </template>
  </ChartCard>
</template>

<script>
// import Vue from 'vue'
import ChartCard from './../../../components/index'
// import Loading from "element-ui"
import moment from "moment"

// Vue.use(Loading.directive)

export default {
  components: {
    ChartCard
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
   },
  data: () => ({
    bankroll: "",
    weekProfit: "",
    todayProfit: "",
    loadingLastWeekOrders: false,
    lineChart: {
      data: {
        labels: [],
        series: []
      },
      options: {
        showArea: false,
        height: "245px",
        axisX: {
          showGrid: false
        },
        responsive: true,
        hoverMode: 'index',
        stacked: false,
        lineSmooth: true,
        showLine: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          right: 50
        },
      },
      responsiveOptions: [
        [
          "screen and (max-width: 640px)",
          {
            axisX: {
              labelInterpolationFnc: function(value) {
                return value[0];
              }
            }
          }
        ]
      ]
    }
  }),
  created () {
    this.fetchLastWeekOrders()
  },
  methods: {
    fetchLastWeekOrders() {
      this.loadingLastWeekOrders = true;
      this.axios
      .get('/orders/lastweek')
      .then(response => {
        let labels = []
        let serie = []
        this.weekProfit = 0
        if (response.data.orders) {
          let orders = response.data.orders

          for (let i = orders.length - 1; i >= 0; i--) {
            serie.push(parseFloat(orders[i].bankroll))
            labels.push(moment(orders[i].created_at).locale('pt-br').calendar().toString())
            if (orders[i].kind === 'order') {
              this.weekProfit += (orders[i].bankroll - orders[i].old_bankroll)
            }
          }
          this.weekProfit = Number.parseFloat(this.weekProfit + '').toFixed(2)
          this.lineChart.data.labels = labels
          this.lineChart.data.series.push(serie)
        }
        this.loadingLastWeekOrders = false
      })
      .catch(error => {
        console.log(error)
        this.loadingLastWeekOrders = false
      })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Grafic.vue